export default __webpack_public_path__ + "static/media/WallNotification_MCC-Picture.b6369064.png";